import { SCREEN_CODE } from '../../PhoneVerification/types'
import {
  ButtonTracking,
  ScreenTracking,
  SCREEN_ASSET_ID
} from '../../../domain/amplitude'

export type PromoCodeValues = {
  promocode: string
}

export type PromoCodeComponentState = {
  promocode: string
  skipped: boolean
}

export type PromoCodeComponentProps = {
  inValidCode: boolean
  setFormData: (data: PromoCodeValues) => void
  formData: PromoCodeValues
  onSkip: (step?: number) => void
}

export const PROMO_SCREEN = 'application_promo'

export const PromoScreenOpenedEvent: ScreenTracking = {
  heading: 'Have a promo code',
  screen: PROMO_SCREEN,
  asset_id: SCREEN_ASSET_ID,
  from_screen: SCREEN_CODE
}

export const PromoNextButtonEvent: ButtonTracking = {
  asset_id: 'nextButton',
  asset_text: 'NEXT',
  screen: PROMO_SCREEN
}

export const SkipButtonEvent: ButtonTracking = {
  asset_id: 'skipButton',
  asset_text: 'skip this step',
  screen: PROMO_SCREEN
}
